import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber, injectIntl, intlShape } from 'react-intl';
import { map, isEmpty, filter, get } from 'lodash';
import Table from './Table';
import { Tooltip } from '../elements-tooltip/tooltip-v2';

class PayoutTable extends Component {
  constructor (props) {
    super(props);

    this.parentTooltipRef = element => {
      this.tooltipRef = element;
    };
  }

  render () {
    const {
      currency = 'USD',
      spaceRentalTotal = 0,
      addOnsTotal = 0,
      total = 0,
      hostPayout = 0,
      guestFee = 0,
      hostFee = 0,
      guestPayment = 0,
      discounts = {},
      iosWebView = false,
      itemsArray = [],
      hostAddOnsSummary = {},
      masterContract = {}
    } = this.props;

    const tableHeaders = [
      { label: this.props.intl.formatMessage({ id: 'inbox.payout_table.Payout', defaultMessage: 'Payout' }) }
    ];

    const conciergeAddOns = filter(itemsArray, (item) => {
      return item.meta.is_concierge;
    });

    const masterCalc = get(masterContract, 'calculations');
    const spaceRentalSalesTax = get(masterCalc, 'guest.us_sales_tax_space_rental', 0);
    const addOnsSalesTax = get(masterCalc, 'guest.us_sales_tax_add_ons', 0);

    const displayAddOns = get(masterCalc, 'host_add_ons_summary') ||
      (addOnsTotal && !conciergeAddOns.length);

    return (
      <div ref={this.parentTooltipRef} className="PayoutTable payout-table margin-lg-bottom">
        <Table
          tableHeaders={tableHeaders}
          tableBody={
            <div>
              <div className="flex space-between table-row">
                <div>
                  <FormattedMessage
                    id='inbox.payout_table.space_rental_total'
                    defaultMessage='Space rental total'
                  />
                </div>
                <div data-testing-id="space-rental-total">
                  <FormattedNumber value={spaceRentalTotal} currency={currency} style={'currency'} />
                </div>
              </div>

              {
                !!displayAddOns &&
                  <div className="flex space-between table-row">
                    <div>
                      <FormattedMessage
                        id='inbox.payout_table.addons_total'
                        defaultMessage='Add-ons total'
                      />
                    </div>
                    <div data-testing-id="add-ons-total">
                      <FormattedNumber value={get(hostAddOnsSummary, 'amount') || addOnsTotal} currency={currency} style={'currency'} />
                    </div>
                  </div>
              }

              <hr className="dotted margin-md-top margin-md-bottom" />

              <div className="flex space-between table-row heavy">
                <div className="heavy">
                  <FormattedMessage
                    id='inbox.payout_table.total'
                    defaultMessage='Total'
                  />
                </div>
                <div data-testing-id="total">
                  <FormattedNumber value={total} currency={currency} style={'currency'} />
                </div>
              </div>

              <hr className="dotted margin-md-top margin-md-bottom" />

              <div className="flex space-between table-row your-payout heavy">
                <div className="flex space-between">
                  <div>
                    <FormattedMessage
                      id='inbox.payout_table.your_payout'
                      defaultMessage='Your payout'
                    />
                  </div>
                  {
                    !iosWebView &&
                      <Tooltip
                        hideOnClickAnywhere
                        placement="right"
                        tooltipClass="payout-tooltip"
                        anchorType="default"
                        parentNode={this.parentTooltipRef}
                        arrowPlacement={{ arrowOffsetTop: 100 }}
                      >
                        <div className="flex space-between margin-sm-bottom">
                          <div>
                            <FormattedMessage
                              id='inbox.payout_table.rental_total'
                              defaultMessage='Space rental total'
                            />
                          </div>
                          <div>
                            <FormattedNumber value={spaceRentalTotal} currency={currency} style={'currency'} />
                          </div>
                        </div>

                        { !!displayAddOns &&
                          <div className="flex space-between margin-sm-bottom">
                            <div>
                              <FormattedMessage
                                id='inbox.payout_table.add_ons_total'
                                defaultMessage='Add-ons total'
                              />
                            </div>
                            <div>
                              <FormattedNumber value={get(hostAddOnsSummary, 'amount') || addOnsTotal} currency={currency} style={'currency'} />
                            </div>
                          </div> }

                        <div className="flex space-between">
                          <div>
                            <FormattedMessage
                              id='inbox.payout_table.fee'
                              defaultMessage='Service fee'
                            />
                          </div>
                          <div data-testing-id="host-fee">-<FormattedNumber value={hostFee} currency={currency} style={'currency'} /></div>
                        </div>

                        <hr className="dotted margin-md-top margin-md-bottom" />

                        <div className="flex space-between heavy payout-total">
                          <div>
                            <FormattedMessage
                              id='inbox.payout_table.payout_total'
                              defaultMessage='Payout total'
                            />
                          </div>
                          <div data-testing-id="host-payout">
                            <FormattedNumber value={hostPayout} currency={currency} style={'currency'} />
                          </div>
                        </div>

                      </Tooltip>
                  }
                </div>
                <div data-testing-id="host-payout">
                  <FormattedNumber value={hostPayout} currency={currency} style={'currency'} />
                </div>
              </div>

              {
                !conciergeAddOns.length &&
                <div className="flex space-between table-row heavy">
                  <div className="flex space-between">
                    <div>
                      <FormattedMessage
                        id='inbox.payout_table.guest_pay'
                        defaultMessage='Guest will pay'
                      />
                    </div>
                    {
                      !iosWebView &&
                        <Tooltip
                          hideOnClickAnywhere
                          placement="right"
                          tooltipClass="payout-tooltip"
                          anchorType="default"
                          parentNode={this.parentTooltipRef}
                        >
                          <div className="flex space-between margin-sm-bottom">
                            <div>
                              <FormattedMessage
                                id='inbox.payout_table.space_total'
                                defaultMessage='Space rental total'
                              />
                            </div>
                            <div>
                              <FormattedNumber value={spaceRentalTotal} currency={currency} style={'currency'} />
                            </div>
                          </div>

                          { spaceRentalSalesTax > 0 && (
                            <div className="flex space-between margin-sm-bottom">
                              <div>
                                <FormattedMessage
                                  id='inbox.payout_table.space_rental_sales_tax'
                                  defaultMessage='Space rental sales tax'
                                />
                              </div>
                              <div>
                                <FormattedNumber value={spaceRentalSalesTax} currency={currency} style={'currency'} />
                              </div>
                            </div>
                          )}

                          { !isEmpty(itemsArray) &&
                            <div className="flex space-between margin-sm-bottom">
                              <div>
                                <FormattedMessage
                                  id='inbox.payout_table.addons_total_concierge'
                                  defaultMessage='Add-ons total'
                                />
                              </div>
                              <div>
                                <FormattedNumber value={addOnsTotal} currency={currency} style={'currency'} />
                              </div>
                            </div> }

                          {addOnsSalesTax > 0 && (
                            <div className="flex space-between margin-sm-bottom">
                              <div>
                                <FormattedMessage
                                  id='inbox.payout_table.addons_sales_tax'
                                  defaultMessage='Add-ons sales tax'
                                />
                              </div>
                              <div>
                                <FormattedNumber value={addOnsSalesTax} currency={currency} style={'currency'} />
                              </div>
                            </div>
                          )}

                          { map(discounts, (discount, i) => {
                            return (
                              <div className="flex space-between margin-sm-bottom" key={`discount-${i}`}>
                                <div>{discount.title}</div>
                                <div>-<FormattedNumber value={discount.discount_amount} currency={currency} style={'currency'} /></div>
                              </div>
                            );
                          })}

                          <div className="flex space-between">
                            <div>
                              <FormattedMessage
                                id='inbox.payout_table.processing_fee'
                                defaultMessage='Processing fee'
                              />
                            </div>
                            <div>
                              <FormattedNumber value={guestFee} currency={currency} style={'currency'} />
                            </div>
                          </div>

                          <hr className="dotted margin-md-top margin-md-bottom" />

                          <div className="flex space-between heavy payout-total">
                            <div>
                              <FormattedMessage
                                id='inbox.payout_table.guest_pay'
                                defaultMessage='Guest will pay'
                              />
                            </div>
                            <div>
                              <FormattedNumber value={guestPayment} currency={currency} style={'currency'} />
                            </div>
                          </div>
                        </Tooltip>
                    }
                  </div>
                  <div data-testing-id="guest-payment">
                    <FormattedNumber value={guestPayment} currency={currency} style={'currency'} />
                  </div>
                </div>
              }

            </div>
          }
        />
      </div>
    );
  }
}

PayoutTable.propTypes = {
  total: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  spaceRentalTotal: PropTypes.number,
  addOnsTotal: PropTypes.number,
  hostPayout: PropTypes.number,
  guestFee: PropTypes.number,
  hostFee: PropTypes.number,
  guestPayment: PropTypes.number,
  discounts: PropTypes.array,
  iosWebView: PropTypes.bool,
  currency: PropTypes.string,
  itemsArray: PropTypes.array,
  intl: intlShape
};

export default injectIntl(PayoutTable);
